(() => {
  const isDesktop = () => window.matchMedia('(min-width: 990px)').matches;

  const bindHover = () => {
    if (!isDesktop()) return;

    document.querySelectorAll('details.mega-menu[data-mega-hover="true"]').forEach((details) => {
      if (details.dataset.hoverBound === '1') return;
      details.dataset.hoverBound = '1';

      const summary = details.querySelector('summary');
      const content = details.querySelector('.mega-menu__content');
      if (!summary || !content) return;

      let closeTimer;

      const openMenu = () => {
        clearTimeout(closeTimer);
        details.open = true;
        details.setAttribute('open', '');
      };

      const closeMenu = () => {
        clearTimeout(closeTimer);
        closeTimer = setTimeout(() => {
          if (!details.matches(':hover')) {
            details.open = false;
            details.removeAttribute('open');
          }
        }, 120);
      };

      details.addEventListener('pointerenter', openMenu);
      details.addEventListener('pointerleave', closeMenu);
      content.addEventListener('pointerenter', openMenu);
      content.addEventListener('pointerleave', closeMenu);

      // prevent click toggle issues on desktop hover mode
      summary.addEventListener('click', (e) => {
        if (isDesktop()) e.preventDefault();
      });

      // Accessibility
      summary.addEventListener('focus', openMenu);
      details.addEventListener('focusout', () => {
        closeTimer = setTimeout(() => {
          if (!details.contains(document.activeElement)) {
            details.open = false;
            details.removeAttribute('open');
          }
        }, 150);
      });
    });
  };

  document.addEventListener('DOMContentLoaded', bindHover);
  document.addEventListener('shopify:section:load', bindHover);
  window.addEventListener('resize', bindHover);
})();


// Navigation logic removed to allow whole text and arrow to toggle menu
